import { Layout } from 'antd';
import { Content } from 'antd/lib/layout/layout';

import OAMSider from '../oam-sider';

import idataCodingStyles from "../../common/global-styles/idatacoding.module.less";
import projectStyles from "../../project/project.module.less";
import React, {useEffect, useRef, useState} from "react";
import { Table, message, Col, Row, Tabs, Button, Input, Popconfirm, Modal, ConfigProvider, Pagination } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, FieldNumberOutlined, EditOutlined,} from '@ant-design/icons';
import zhCN from 'antd/lib/locale/zh_CN';
import ProfileOutlined from "@ant-design/icons/lib/icons/ProfileOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";

import studentempty from "../../../static/image/studentempty@2x.png";

import {BACKEND_API_URL } from '../../../constants/constants';

import SplitPane from 'react-split-pane';
//import "./project-split-pane.css";
import MonacoEditor from 'react-monaco-editor';
import { sendHttpPostRequest } from "../../../api/http-request";
import Cookies from "js-cookie";
import {CopyToClipboard} from 'react-copy-to-clipboard';

const {TabPane} = Tabs
const TSplitPane:any = SplitPane
export interface Props {}

/** OAM 教室预览 */
export const OAMClassRoomDetail: React.FC<Props> = (props) => {

    const classroom_id =  parseInt(window.location.search.split("=")[1]);  // 习题的ID
  
    const [classRoomInfo, setClassRoomInfo] = useState(null as any);//班级信息
    const [classStudentList, setClassStudentList] = useState(null as any);//班级学生列表
    const [classStudentTotalCount, setClassStudentTotalCount] = useState(null as any);//班级学生总数
    const [classStudentResultSum, setClassStudentResultSum] = useState(null as any);//满足查询条件的学生数量

    const [editClassRoomName, setEditClassRoomName]= useState(null as any);//编辑的班级名称
    const [editClassRoomNumber, setEditClassRoomNumber]= useState(null as any);//编辑的班级名称
    const [editClassRoomPasswd, setEditClassRoomPasswd]= useState(null as any);//编辑的班级名称

    const [sudentCode, setStudentCode] = useState(null as any);//学生任务代码
    const [studentAnswer, setStudentAnswer] = useState(null as any);//学生任务答案

    const [currentTask, setCurrentTask]= useState(null as any);//教师点击的当前任务

    const [studentName, setStudentName] = useState(null as any);//当前学生的姓名
    const [studentAvatar, setStudentAvatar] = useState(null as any);//当前学生的头像

    const [showClassPasswd, setShowClassPasswd] = useState(false);//


    const [activeTabkKey,setActiveTabkKey] = useState("1"); 
    const page = useRef(1);//当前学生页
    const pageSize = useRef(15);//每页学生数量
    const queryStudentContent = useRef("");//查询字符串

    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);
 
    const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);

 

    const editorReadOnlyoptions = {
        readOnly:true,
        selectOnLineNumbers: true,
        fontSize:14,
        minimap:{enabled:false},
        lineDecorationsWidth: 5,
        lineNumbersMinChars:2,
        quickSuggestions:false,
        automaticLayout: true,  // 拖拽分屏线时自适应宽度

    }


    useEffect(()=> {
        queryClassRoom();
    }, []);

    /** 查询班级信息 */
    const queryClassRoom = () => {

    sendHttpPostRequest(
        'classroom/api/oam_query_classroom_by_id/',
        {
            sessionid: Cookies.get("sessionid"),
            classroom_id: classroom_id,
            query: queryStudentContent.current,
            page: page.current,
            pagesize: pageSize.current
        },
        (response: any) => {
            message.destroy();
            if (response.is_ok == true) {
                setClassRoomInfo(response.query_info);
                setClassStudentList(response.query_info.student_list);
                setEditClassRoomName(response.query_info.name);
                setEditClassRoomNumber(response.query_info.number);
                setEditClassRoomPasswd(response.query_info.password); 
                setClassStudentTotalCount(response.student_total_count);
                setClassStudentResultSum(response.student_result_sum);
                
            } /*else if (response.code == -501) {
                权限不足
                window.location.href = '/oam_login?next=oam_menu';
            } */else {
                message.error(response.message);
            }
        }
    )
}
    /** 编辑更新班级信息 */
    const updateClassRoom = (classroom_id, class_password, class_name, class_number) => {
        if(class_password.trim() == ''){
            message.error("班级密码不能为空！")
            return ''
        }
        if(class_name.trim() == ''){
            message.error("班级名称不能为空！")
            return ''
        }

        sendHttpPostRequest(
            'classroom/api/user_update_classroom/',
            {
                sessionid: Cookies.get("sessionid"),
                classroom_id: classroom_id,
                password: class_password,
                name: class_name,
                number: class_number,
            },
            (response: any) => {
                message.destroy();
                if (response.code == -100) {
                    // 未登录
                    document.getElementById("show-login-modal")!.click();
                } else if (response.is_ok == true) {
                    //message.success("教室创建成功~");
                    queryClassRoom();
                    setIsEditModalVisible(false);

                } /*else if (response.code == -501) {
                    权限不足
                    window.location.href = '/oam_login?next=oam_menu';
                } */else {
                    message.error(response.message);
                }
            }
        )
    }

        /** 查询班级信息 */
        const queryClassRoomStudentSubmission = (user_id, exercise_id) => {

            sendHttpPostRequest(
                'classroom/api/user_query_classroom_student_submission/',
                {
                    sessionid: Cookies.get("sessionid"),
                    exercise_id: exercise_id,
                    user_id:user_id,
    
                },
                (response: any) => {
                    message.destroy();
                    if (response.code == -100) {
                        // 未登录
                        document.getElementById("show-login-modal")!.click();
                    } else if (response.is_ok == true) {
                        setStudentCode(response.code);
                        setStudentAnswer(response.answer);
                        setIsDetailModalVisible(true);   
                    } /*else if (response.code == -501) {
                        权限不足
                        window.location.href = '/oam_login?next=oam_menu';
                    } */else {
                        message.error(response.message);
                    }
                }
            )
        }

       /** 查询班级信息 */
       const deleteClassRoomStudent = (user_id: any) => {

        sendHttpPostRequest(
            'classroom/api/user_remove_classroom_student/',
            {
                sessionid: Cookies.get("sessionid"),
                classroom_id: classroom_id,
                user_id:user_id,
            },
            (response: any) => {
                message.destroy();
                if (response.code == -100) {
                    // 未登录
                    document.getElementById("show-login-modal")!.click();
                } else if (response.is_ok == true) {
                    message.success("移出成功~");
                    queryClassRoom();
                } /*else if (response.code == -501) {
                    权限不足
                    window.location.href = '/oam_login?next=oam_menu';
                } */else {
                    message.error(response.message);
                }
            }
        )
    }

    const handleEditOk = () => {
        setIsEditModalVisible(false);
        setIsDetailModalVisible(false);
    };

    const handleEditCancel = () => {
        setIsEditModalVisible(false);
        setIsDetailModalVisible(false);
    };

    const editClass = () => {
        setIsEditModalVisible(true);
    }

    //页码和页数发生了变化
    const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
        page.current = newPage ? newPage : 1;
        if (newPageSize) {
            pageSize.current = newPageSize;
        }
       queryClassRoom();
    }


    /** 任务状态和颜色的映射 */
    const getColorByStatus = (status:number)=>{
        if (status == 0) {
          return "#f2f2f2"
        }else if (status == 1){
          return "#9a3232"
        }else {
          return "#4f46e5"
        }
      }
  
    /** 答题状态和题号颜色的映射 */
    const getFontColorByStatus = (status:number)=>{
    if (status == 0) {
        return "#4f46e5"
    }else{
        return "#fff"
    }
    }
    // 渲染操作
    const renderClassRoomActions = (text:any, record:any) => {
        return   <Popconfirm placement="top" title={'您确定将该学员移出本班级吗？'} onCancel={(e:any)=>{}} onConfirm={(e:any)=>{deleteClassRoomStudent(record.user_id);}} okText="确认" cancelText="取消">
        <Button style={{color:"#f2f2f2",borderRadius:20,fontSize:14}} size='small'  type="link">   移出 </Button>
    </Popconfirm>
        
        
    }

    const renderInfo = (text:any, record:any, index:any) => {
        return <div>
            <img  src={ record.avatar?.startsWith("http") ? record.avatar : BACKEND_API_URL + record.avatar} alt="" 
            style={{width:36,height:36,borderRadius:18,marginBottom:10}}/>
            <div>{record.real_name == "" ? record.user_name : record.real_name}</div>
        </div>
    }

    const renderTask = (menu:any, record: any, index: any) => {
      
      
        return  <div style={{padding:10}} >
        <Row justify="end" align="middle" gutter={[8,8]} style={{marginBottom:10}}>
            <Col>
        <div style={{fontSize:12,height:12,width:12,backgroundColor:"#4f46e5"}}></div></Col>
                <Col style={{fontSize:12}}>通过 {record.pass_count} </Col>
                <Col><div  style={{height:12,width:12,background:"#9a3232"}}></div></Col>
                
                <Col style={{fontSize:12}}>未通过 {record.fail_count} </Col>
                <Col><div style={{height:12,width:12,background:"#f2f2f2"}}></div></Col>
            
                <Col style={{fontSize:12}}>未提交 {record.not_count} </Col>
        </Row>
        <div  style={{marginTop:-30}}>
                { menu?.map((chapter:any,index:number)=>(<>
                    <Row align='middle' justify= {'start'} gutter={[2,2]} style={{textAlign:"left",width:"100%"}}> 
                        <Col>
                            <div style={{textAlign:"center",borderRadius:12,height:24,width:24, backgroundColor:'#eee'}}> { chapter.is_pass == 0 ? <LockOutlined /> : (index + 1)} </div>
                        </Col>  
                        { chapter?.tasks?.map((task:any,taskInd:number)=>(
                                <Col key={index}>
                                    <div  
                                    onClick={()=>{setCurrentTask(task);setStudentAvatar(record.avatar);setStudentName(record.real_name == "" ? record.user_name : record.real_name);queryClassRoomStudentSubmission(record.user_id,task.id )}}
                                    style={{backgroundColor:getColorByStatus(task.status),color:getFontColorByStatus(task.status),margin:5,padding:"auto",textAlign:"center",height:24,lineHeight:'24px',width:24,fontSize:12,borderRadius:2,cursor:'pointer'}}   
                                    >
                                        {taskInd+1}
                                    </div> 
                                </Col>
                            ))      
                        }
                    
                    </Row>
                </>))      
                }
        </div>  
    </div>
    }


    // 表格列
    const student_cols: any = [
        {
            title: "序号",
            dataIndex: "user_id",
            key: "user_id",
            width: '60px',
            align: 'center',
            render:(text, record)=>((page.current - 1)*pageSize.current + classStudentList.indexOf(record)+ 1)
        },
        {
            title: "",
            dataIndex: "real_name",
            key: "real_name",
            width: '50px',
            align: 'left',
            render: (text:any, record:any, index:any) => {
                return <img  src={ record.avatar?.startsWith("http") ? record.avatar : BACKEND_API_URL + record.avatar} alt="" 
                style={{width:36,height:36,borderRadius:18,marginRight:10}}/>}
        },
        {
            title: "姓名",
            dataIndex: "real_name",
            key: "real_name",
            width: '100px',
            align: 'left',
            render: (text,record) => (record.real_name == "" ? record.user_name : record.real_name )
        },
        {
            title: "学号",
            dataIndex: "number",
            key: "number",
            width: '100px',
            align: 'left',
        },
        {
            title: "加入日期",
            dataIndex: "join_time",
            key: "join_time",
            width: '120px',
            align: 'left',
            render:(text)=>(text?.slice(0,10))
        },
        {
            title: "实训进度",
            dataIndex: "complete_percent",
            key: "complete_percent",
            width: '80px',
            align: 'center'
        },
        {
            title: "报告",
            dataIndex: "report",
            key: "report",
            width: '80px',
            align: 'center',
        },
        {
            title: "操作",
            dataIndex: "actions",
            key: "actions",
            width: '120px',
            ellipsis: false,
            align: 'center',
            //fixed: 'right',
            render: renderClassRoomActions ,
        },
    ]

    const task_cols: any = [
        {
            title: "序号",
            dataIndex: "user_id",
            key: "user_id",
            width: '60px',
            align: 'center',
            render:(text, record)=>((page.current - 1)*pageSize.current + classStudentList.indexOf(record)+ 1)
        },{
            title: "姓名",
            dataIndex: "real_name",
            key: "real_name",
            width: '100px',
            align: 'center',
            render: renderInfo,
        },{
            title: "实训任务",
            dataIndex: "menu",
            key: "menu",
            width: '400px',
            align: 'center',
            render: renderTask,
        },
    ]



    return (
        <Layout style={{ minHeight: '100vh' }}>
        <OAMSider keys={"8"} openKeys={["sub-project"]} ></OAMSider>
        <div>
            <Content style={{ backgroundColor:'#fff',borderRadius:5,minWidth:1000,margin:30 ,paddingTop:20,width:"calc(100vw - 300px)"}}>
            <div  style={{minWidth:800,padding:"5px 0px 5px 0px",borderRadius:10,margin:"15px 20px 15px 20px",height:"calc(100vh - 90px)"}}> 
        <div >
            <Row align="middle" style={{margin:0,height: 50}}>
                <Col span={6} style={{fontSize:16,textAlign:"left"}}  > 
                    {classRoomInfo?.name}    
                </Col>
                 <Col span={6} style={{fontSize:16,textAlign:"left"}}  > 
                    班号：{classRoomInfo?.number}   
                </Col>

                <Col span={4} style={{fontSize:16,textAlign:"left"}}  > 
                    教师：{classRoomInfo?.user_name} 
                </Col>
                
                <Col span={4} style={{fontSize:16,textAlign:"left"}}  > 
                 <span style={{width:80}}>密码： { showClassPasswd == true ? classRoomInfo?.password : "******"} </span>

                 {showClassPasswd == true ? <EyeInvisibleOutlined style={{marginLeft:5}} onClick={()=>{setShowClassPasswd(false)}}/> :
                  <EyeOutlined style={{marginLeft:5}} onClick={()=>{setShowClassPasswd(true)}} /> }

                  <CopyToClipboard text={"项目：" + classRoomInfo?.course_name  + "，教室：" + classRoomInfo?.name+ "，加入密码为：" + classRoomInfo?.password } 
                                        onCopy={() => {message.success("教室密码已复制~")}}>
                    <Button size="small" type="primary" style={{marginLeft:5}}>复制</Button>
                  </CopyToClipboard>
                     
                </Col>
                <Col span={4} style={{fontSize:16,textAlign:"left"}}  > 
                    学生数：{classStudentTotalCount}  
                </Col>
               
            </Row>
        </div>
        <div style={{height:1, backgroundColor:"#0c0a23",opacity:0.5}}></div>
        <Tabs  activeKey={activeTabkKey} onTabClick={(key,event)=>{setActiveTabkKey(key)}} 
            type="line" size="middle" tabPosition="top"
            style={{position:'relative'}}> 

            <TabPane  tab={<div>学生信息</div>}   key="1">
                <div style={{overflowY:'auto',height:"calc(100vh - 200px)",marginBottom:0}}>
                    <div className={idataCodingStyles.tableWrapper}>
                        <div style={{display:'inline-block',position:'absolute',right:45,top:10}}>
                            {/*<Button style={{width:90,marginRight:10,borderRadius:27,color:'#f2f2f2',border:'1px solid #f2f2f2',backgroundColor:'transparent'}}>删除</Button>
                            <Button style={{width:90,borderRadius:27,color:'#f2f2f2',backgroundColor:'#4f46e5',border:0}}>导出报告</Button>
                            */}
                        </div>
                        {classStudentList?.length!=0?
                            <Table
                                className={projectStyles.studentTable}
                                dataSource={classStudentList}
                                columns={student_cols}
                                rowKey={record => record.user_id}
                                //pagination={{size:"default",position:["bottomCenter"],defaultPageSize:10,defaultCurrent:1,hideOnSinglePage:true,itemRender:itemRender}}
                                scroll={{ x: 800 }}
                                pagination={false}
                                size="small"                               
                                //rowSelection={rowSelection}
                            />
                        :<div style={{width:'100%',textAlign:'center',color:'#ccc'}}>
                            <img src={studentempty} alt="" width={200} height={200} style={{margin:'40px auto'}}/>
                            <p>该班级还没有学生</p>
                            <p>快去邀请学生加入班级吧！</p>
                        </div>}
                    </div>
                    <ConfigProvider locale={zhCN}>
                            <div style={{marginBottom:20,paddingTop:20, textAlign:"center"}} >
                                <Pagination
                                    defaultCurrent={1}
                                    total={classStudentResultSum}
                                    defaultPageSize={15}
                                    current={page.current}
                                    hideOnSinglePage={true}
                                    onChange={onPageChange}
                                />
                            </div>
                    </ConfigProvider>
                </div>

            </TabPane>

             <TabPane tab={<div>任务进度</div>}   key="2">
                <div  style={{overflowY:'auto',height:"calc(100vh - 200px)",marginBottom:0}}>
                    <div className={idataCodingStyles.tableWrapper}>
                        {classStudentList?.length!=0?
                            <Table
                                dataSource={classStudentList}
                                columns={task_cols}
                                rowKey={record => record.user_id}
                                pagination={false}
                                //pagination={{size:"default",position:["bottomCenter"],defaultPageSize:3,defaultCurrent:1,hideOnSinglePage:true,itemRender:itemRender}}
                                scroll={{ x: 800 }}
                                size="small"
                            />
                        :<div style={{width:'100%',textAlign:'center',color:'#ccc'}}>
                            <img src={studentempty} alt="" width={200} height={200} style={{margin:'40px auto'}}/>
                            <p>该班级还没有学生</p>
                            <p>快去邀请学生加入班级吧！</p>
                        </div>}

                        <ConfigProvider locale={zhCN}>
                            <div style={{marginBottom:20,paddingTop:20, textAlign:"center"}} >
                                <Pagination
                                    defaultCurrent={1}
                                    total={classStudentResultSum}
                                    defaultPageSize={15}
                                    current={page.current}
                                    hideOnSinglePage={true}
                                    onChange={onPageChange}
                                />
                            </div>
                    </ConfigProvider>
                    </div>
                </div>


                <Modal 
                    title= {<Row gutter={[4,4]} align="middle" justify="start">
                       <Col flex="30px"> <img  src={ studentAvatar?.startsWith("http") ? studentAvatar : BACKEND_API_URL + studentAvatar} alt="" 
                             style={{width:28,height:28,borderRadius:14,marginRight:10}} />
                        </Col>
                        <Col flex="20x0px" > <span style={{width:120,color:"#f2f2f2"}}>{studentName}</span> </Col>
                        <Col flex="auto"> <span style={{width:120,color:"#f2f2f2"}}>{currentTask?.name}</span> </Col>
                    </Row>
                    }
                    width={800}
                    bodyStyle={{height:460,overflowY:'auto'}}
                    closable={true}
                    centered={true}
                    visible={isDetailModalVisible}
                    onCancel={()=>{setIsDetailModalVisible(false)}}
                    className={projectStyles.detailModal}
                    footer={[]}
                >
                    <div className="project-learn-page">
                     <TSplitPane  allowResize={true} split="vertical" defaultSize={"50%"} >
                        <div >
                            <div style={{marginLeft:10,marginBottom:10}}> 学生代码 </div>
                            <div className={projectStyles.userCode} style={{width:"100%"}}>
                                <MonacoEditor
                                    width="100%"
                                    height="400px"
                                    language="python"
                                    theme={"vs-dark"} 
                                    value={sudentCode}
                                    options={editorReadOnlyoptions}
                                />  
                            </div>
                        </div>

                        <div>
                            <div style={{marginLeft:10,marginBottom:10}}> 参考代码 </div>
                            <div className={projectStyles.userCode} style={{width:"100%"}}>
                                    <MonacoEditor
                                        width="100%"
                                        height="400px"
                                        language="python"
                                        theme={"vs-dark"} 
                                        value={studentAnswer}
                                    options={editorReadOnlyoptions}
                                />  
                            </div>
                        </div>

                        </TSplitPane>
                    </div>
                      
                </Modal>
                </TabPane> 

        </Tabs>
              
    </div>
            </Content>
        </div>
    </Layout>
    )

}

export default OAMClassRoomDetail

